<script lang="ts" setup>
import { rankingConfig as config } from './configs/vowpath'
import RankingPageVowpath from './components/RankingPage.vowpath.vue'

defineProps<{
  columnId: string
}>()

const RankingPage = RankingPageVowpath
</script>

<template>
  <div class="bg-white">
    <!-- 🔥 品牌专属页面组件 -->
    <RankingPage :column-id="columnId" :config="config" />
  </div>
</template>
